"use client";
import Image from "next/image";
import React from "react";

export default function FaImage({
  src,
  alt,
  width,
  height,
  classes = "",
  imgClasses = "",
}) {
  const defaultWidth = 165;
  const defaultHeight = 48;

  const imageWidth = width || defaultWidth;
  const imageHeight = height || defaultHeight;

  return (
    <div
      className={`main_logo relative overflow-hidden ${classes}`}
      style={{ width: imageWidth, height: imageHeight }}
    >
      <Image
        src={src}
        alt={alt}
        width={imageWidth}
        height={imageHeight}
        className={`${imgClasses}`}
      />
    </div>
  );
}